import { sharingMessages, techAgentId } from 'constants/history';
import { MessageType } from 'enums/MessageType';
import { all, put, takeEvery } from 'redux-saga/effects';
import { addClientSideMessage } from 'state/history/history.actions';
import { getNetworkTime } from 'utils/dateTime';
import { randomUuid } from 'utils/random';

import { ReceiveSharingMessageAction, sharing, SharingActionType } from './sharing.actions';

function* receiveSharingMessageSaga() {
    yield takeEvery(
        SharingActionType.ReceiveSharingMessage,
        function* ({ payload: { msgType } }: ReceiveSharingMessageAction) {
            const sharingMsgOverride = sharingMessages[msgType];

            if (sharingMsgOverride) {
                yield put(
                    addClientSideMessage({
                        type: MessageType.Text,
                        agentId: techAgentId,
                        text: sharingMsgOverride,
                        time: getNetworkTime() / 1000,
                        uuid: randomUuid(),
                    }),
                );

                if (msgType === MessageType.SharingRequest) {
                    yield put(sharing.clOperatorRequestsSharing());
                }

                return;
            }
        },
    );
}

export function* sharingSaga() {
    yield all([receiveSharingMessageSaga()]);
}
